<div class="row">
  <div class="col-12 text-center small mt-2" *ngIf="!interaction?.completed.onComplete">
    <span *ngIf="localStorage.getItem('l') === 'it'">Risposte corrette: {{errorIdsFound}} su {{errorIds?.length}}</span>
    <span *ngIf="localStorage.getItem('l') === 'en'">Correct answers: {{errorIdsFound}} on {{errorIds?.length}}</span>
    <span *ngIf="localStorage.getItem('l') === 'fr'">Bonnes réponses: {{errorIdsFound}} sur {{errorIds?.length}}</span>
  </div>
  <div class="col-12 mt-3 mb-3">
    <!-- TROVA ERRORE-->
    <div class="d-flex flex-wrap" id="image_wrapper" #trovaerrore>
      <div class="trovaerrore-items"
        *ngFor="let item of items"
        [style.backgroundImage]="'url('+ image +')'"
        [style.backgroundSize]="puzzleWrapperWidth + 'px ' + (puzzleWrapperWidth *  imageHeight) / imageWidth  + 'px'"
        [style.backgroundPosition]="item.backgroundPosition"
        [style.width]="item?.width + 'px'"
        [style.height]="item?.height + 'px'"
        [style.opacity]="item.opacity"
        [class]="'item-' + item?.id">
      </div>
    </div>
    <div class="d-flex flex-wrap" id="errore_wrapper" *ngIf="interaction.completed.status !== 'success'">
      <div class="trovaerrore-items"
        *ngFor="let item of wrongItems"
        [style.backgroundImage]="'url('+ wrongImage +')'"
        [style.backgroundSize]="puzzleWrapperWidth + 'px ' + (puzzleWrapperWidth *  imageHeight) / imageWidth  + 'px'"
        [style.backgroundPosition]="item.backgroundPosition"
        [style.width]="item?.width + 'px'"
        [style.height]="item?.height + 'px'"
        [style.opacity]="item.opacity"
        (click)="isWrong(item)">
      </div>
    </div>
    <!-- END OF TROVA ERRORE-->
  </div>
</div>

